import { render, staticRenderFns } from "./BoxSlider.vue?vue&type=template&id=668acfb5&scoped=true&"
import script from "./BoxSlider.vue?vue&type=script&lang=js&"
export * from "./BoxSlider.vue?vue&type=script&lang=js&"
import style0 from "./BoxSlider.vue?vue&type=style&index=0&id=668acfb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668acfb5",
  null
  
)

export default component.exports